import { ContentItem } from 'kentico-cloud-delivery';

import get from 'lodash/get';

export default class Accordion extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`,
    });
  }

  get header() {
    return get(this, '_header.value', '');
  }

  get accordionItems() {
    return get(this, '_accordion_items', []);
  }

  get htmlModifiers() {
    return get(this, '_html_modifiers', []);
  }
}



// WEBPACK FOOTER //
// ./src/models/Accordion.model.js